export default "__VITE_ASSET__Dz9awNjE__"